import {
  CREATE_ACCOUNT_BANK,
  CREATE_ACCOUNT_BANK_FAIL,
  CREATE_ACCOUNT_BANK_SUCCESS,
  CREATE_USER_INVOICE,
  CREATE_USER_INVOICE_FAIL,
  CREATE_USER_INVOICE_SUCCESS,
  DELETE_USER_INVOICE,
  DELETE_USER_INVOICE_FAIL,
  DELETE_USER_INVOICE_SUCCESS,
  EDIT_USER_INVOICE,
  EDIT_USER_INVOICE_FAIL,
  EDIT_USER_INVOICE_SUCCESS,
  GET_ALL_ACCOUNT_BANK,
  GET_ALL_ACCOUNT_BANK_FAIL,
  GET_ALL_ACCOUNT_BANK_SUCCESS,
  GET_ALL_USER_INVOICE,
  GET_ALL_USER_INVOICE_FAIL,
  GET_ALL_USER_INVOICE_SUCCESS,
  GET_DETAIL_USER_INVOICE,
  GET_DETAIL_USER_INVOICE_FAIL,
  GET_DETAIL_USER_INVOICE_SUCCESS,
  GET_LIST_USER_INVOICE,
  GET_LIST_USER_INVOICE_FAIL,
  GET_LIST_USER_INVOICE_SUCCESS,
  RESET_CREATE_ACCOUNT_BANK,
  RESET_CREATE_USER_INVOICE,
  RESET_DELETE_USER_INVOICE,
  RESET_EDIT_USER_INVOICE,
  RESET_GET_ALL_ACCOUNT_BANK,
  RESET_GET_ALL_USER_INVOICE,
  RESET_LIST_USER_INVOICE,
  SET_COLUMN_VISIBLE_USER_INVOICE,
} from "./actionTypes";

// Khách hàng
export const getListUserInvoice = params => ({
  type: GET_LIST_USER_INVOICE,
  params,
});

export const getListUserInvoiceSuccess = (listData, totalCount) => ({
  type: GET_LIST_USER_INVOICE_SUCCESS,
  listData,
  totalCount,
});

export const getListUserInvoiceFail = error => ({
  type: GET_LIST_USER_INVOICE_FAIL,
  error,
});

export const resetListUserInvoice = error => ({
  type: RESET_LIST_USER_INVOICE,
});

// Chi tiết Khách hàng
export const getDetailUserInvoice = id => ({
  type: GET_DETAIL_USER_INVOICE,
  id,
});

export const getDetailUserInvoiceSuccess = data => ({
  type: GET_DETAIL_USER_INVOICE_SUCCESS,
  data,
});

export const getDetailUserInvoiceFail = error => ({
  type: GET_DETAIL_USER_INVOICE_FAIL,
  error,
});

// Tạo Khách hàng
export const createUserInvoice = data => ({
  type: CREATE_USER_INVOICE,
  data,
});

export const createUserInvoiceSuccess = data => ({
  type: CREATE_USER_INVOICE_SUCCESS,
  data,
});

export const createUserInvoiceFail = error => ({
  type: CREATE_USER_INVOICE_FAIL,
  error,
});
export const resetCreateUserInvoice = error => ({
  type: RESET_CREATE_USER_INVOICE,
});

// EDIT Khách hàng
export const editUserInvoice = (data, id) => ({
  type: EDIT_USER_INVOICE,
  data,
  id,
});

export const editUserInvoiceSuccess = data => ({
  type: EDIT_USER_INVOICE_SUCCESS,
  data,
});

export const editUserInvoiceFail = error => ({
  type: EDIT_USER_INVOICE_FAIL,
  error,
});
export const resetEditUserInvoice = error => ({
  type: RESET_EDIT_USER_INVOICE,
});

// Delete Khách hàng
export const deleteUserInvoice = id => ({
  type: DELETE_USER_INVOICE,
  id,
});

export const deleteUserInvoiceSuccess = data => ({
  type: DELETE_USER_INVOICE_SUCCESS,
  data,
});

export const deleteUserInvoiceFail = error => ({
  type: DELETE_USER_INVOICE_FAIL,
  error,
});

export const resetDeleteUserInvoice = error => ({
  type: RESET_DELETE_USER_INVOICE,
});

// getAllUserInvoice
export const getAllUserInvoice = type_id => ({
  type: GET_ALL_USER_INVOICE,
  type_id,
});

export const getAllUserInvoiceSuccess = data => ({
  type: GET_ALL_USER_INVOICE_SUCCESS,
  data,
});

export const getAllUserInvoiceFail = error => ({
  type: GET_ALL_USER_INVOICE_FAIL,
  error,
});

export const resetGetAllUserInvoice = error => ({
  type: RESET_GET_ALL_USER_INVOICE,
});

// getAllAccountBank
export const getAllAccountBank = () => ({
  type: GET_ALL_ACCOUNT_BANK,
});

export const getAllAccountBankSuccess = data => ({
  type: GET_ALL_ACCOUNT_BANK_SUCCESS,
  data,
});

export const getAllAccountBankFail = error => ({
  type: GET_ALL_ACCOUNT_BANK_FAIL,
  error,
});

export const resetGetAllAccountBank = error => ({
  type: RESET_GET_ALL_ACCOUNT_BANK,
});

// show/hide column
export const setColumnVisibleUserInvoice = (field, value) => ({
  type: SET_COLUMN_VISIBLE_USER_INVOICE,
  field,
  value,
});

// Tạo Khách hàng
export const createAccountBank = data => ({
  type: CREATE_ACCOUNT_BANK,
  data,
});

export const createAccountBankSuccess = data => ({
  type: CREATE_ACCOUNT_BANK_SUCCESS,
  data,
});

export const createAccountBankFail = error => ({
  type: CREATE_ACCOUNT_BANK_FAIL,
  error,
});
export const resetCreateAccountBank = error => ({
  type: RESET_CREATE_ACCOUNT_BANK,
});
